import React from 'react';
import Head from 'next/head';
import Image from 'next/image';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase/firebaseApp';
import Loader from '../components/Loader';
import ClientsSlider  from '../components/Home/ClientsSlider';
import HeroSection  from '../components/Home/HeroSection';
import FeatureCard  from '../components/Home/FeatureCard';
import SolutionSection  from '../components/Home/SolutionSection';
import CTASection  from '../components/Home/CTASection';
import { SITE, homeJsonLd } from '../lib/seo';

import { 
  Box, // Replaced 'Cube' with 'Box'
  LayoutGrid, 
  Users2, 
  BarChart3, 
  Smartphone, 
  FileText, 
  Bot,
  Building,
  PenTool
} from "lucide-react";
import FeaturesSection from '../components/Home/FeaturesSection';
import ChangeSection from '../components/Home/ChangeSection';


// interface ProcessStepProps {
//   number: string;
//   title: string;
//   description: string;
// }

const ProcessStep = ({ number, title, description }) => {
  return (
    <div className="relative z-10 flex flex-col items-center text-center">
      <div className="w-16 h-16 rounded-full bg-gradient-to-br from-monet-blue to-monet-purple flex items-center justify-center text-white font-bold text-xl font-display mb-6 relative">
        {number}
        <div className="absolute inset-0 rounded-full bg-gradient-to-br from-monet-blue to-monet-purple opacity-30 blur-md"></div>
      </div>
      
      <div className="glass-card p-6 rounded-xl w-full">
        <h3 className="text-xl font-display font-bold mb-3 text-white">{title}</h3>
        <p className="text-white/70">{description}</p>
      </div>
    </div>
  );
};


export default function OnBoardPage() {  
  const [user, loading] = useAuthState(auth);
  // if(loading) return <div className="h-screen pt-80"><Loader /></div>
  return (
    <main>
      <Head>
        <title key="title">Monet: AI floor plans for event designers</title>
        <link rel="canonical" href={`${SITE}/`} key="canonical" />
        <meta name="description" content="Monet is software for event designers to speed up their creative process. Lay out a show floor inside your real venue, to scale, and export DWG, PDF or GLB."/>
        <meta property="og:title" content="Monet, making creativity accessible" />
        <meta property="og:description" content="Monet is software for event designers to speed up their creative process. Lay out a show floor inside your real venue, to scale, and export DWG, PDF or GLB." />
        <meta property="og:image" content="https://monet.io/assets/hero_video_thumbnail.jpg" />
        <meta property="og:url" content={`${SITE}/`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://monet.io/assets/hero_video_thumbnail.jpg" />
        <script type="application/ld+json" key="jsonld" dangerouslySetInnerHTML={{ __html: homeJsonLd() }} />
      </Head>
      {/*user ? <Home user={user}/> : <Story />*/}
      <HeroSection />
      {/* <ClientsSlider /> */}
      <ChangeSection />
      <SolutionSection />
      <FeaturesSection />
      <CTASection />
    </main>
  );
}